import { Reveal } from "@/components/Reveal";

const steps = [
  {
    number: "I",
    title: "Private Conversation",
    description:
      "It begins quietly — learning who you are, what you love, and how you want this moment to feel. Nothing is designed before this is understood.",
  },
  {
    number: "II",
    title: "Bespoke Design",
    description:
      "Together we shape an experience that is entirely yours: the setting, the people, the words, the atmosphere. Every detail intentional.",
  },
  {
    number: "III",
    title: "End-to-End Production",
    description:
      "From the first arrangement to the final candle, everything is handled for you and for everyone involved — with guidance, support, and care.",
  },
];

export const Process = () => {
  return (
    <section
      className="bg-[#7D1B56] py-32 md:py-44"
      data-testid="process-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-[#E0A8C5] mb-6 text-center">
            The Process
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight text-[#FCF5EB] text-center">
            Handled <span className="italic text-[#D9A441]">end to end.</span>
          </h2>
        </Reveal>

        <div className="mt-24 grid md:grid-cols-3 gap-16 md:gap-12">
          {steps.map((step, index) => (
            <Reveal key={step.number} delay={index * 0.15}>
              <div
                className="relative pt-12 border-t border-[#FCF5EB]/40"
                data-testid={`process-step-${index + 1}`}
              >
                <span className="absolute -top-5 left-0 font-serif-display italic font-light text-4xl text-[#D9A441] bg-[#7D1B56] pr-4">
                  {step.number}
                </span>
                <h3 className="font-serif-display font-light text-2xl md:text-3xl text-[#FCF5EB]">
                  {step.title}
                </h3>
                <p className="mt-6 text-sm md:text-base font-light leading-loose text-[#FCF5EB]/85">
                  {step.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
